import { CircleHelp } from 'lucide-react'
import { useLocation } from 'react-router-dom'
import { cn } from '../design/cn'
import { docsFor } from './docsLinks'

/**
 * The header's "?": the documentation about the page you're on, in a new tab (Plans/user-documentation.md).
 */
export function HelpButton() {
  const { pathname } = useLocation()
  return (
    <a
      href={docsFor(pathname)}
      target="_blank"
      rel="noopener"
      aria-label="Help for this page"
      title="Help for this page"
      className={cn(
        'flex h-8 w-8 items-center justify-center rounded-full',
        'text-header-muted transition-colors hover:bg-header-hover hover:text-header-fg',
      )}
    >
      <CircleHelp size={16} aria-hidden="true" />
    </a>
  )
}
